import * as dc from "@/components/layout/list/defaultType";
import { ClipboardProp, DataListParams, DataListProp } from "../../layoutType";
import { runFormFunction } from "../../input/inputFunction";
import dayjs from "dayjs";
import { Debug } from "@/util/debug";
import { DataColumnField, DataColumnRecord } from "../../input/inputType";
import { qcCommonCols, qcCommonInit } from "../../inputCols/qcCols";
import { enLocale } from "@/i18n/routing";
export const CafeQC = (props: DataListProp): DataListParams | undefined => {
  const t = props.t;
  const ta = props.ta;
  const result = props.result;
  const params = props.params;
  const form = props.form;
  const formMemo = props.formMemo;
  const setValueList = props.setValueList;
  const formFunction = props.formFunction;
  const dataFunction = props.dataFunction;
  const alertContext = props.alertContext;

  const utcOffset = dayjs().utcOffset() * 60000;

  const qcNamesCols: DataColumnRecord = {
    cupnote_name_locale: { ...dc.inputFull, readOnly: true, noItem: false, saveData: false },
    cupnote_name: { ...dc.inputFull, readOnly: true, noItem: false, saveData: false },
    cupnote_seq: dc.hidden,
  };
  const qcSubCols: DataColumnRecord = {
    cupnote_main: {
      ...dc.use,
      create: { defaultValue: false },
      edit: { enabledUserAuth: { cafe: ["OWN", "SMNG"] } },
    },
    //rgst_at:{...dc.},
    rgst_by: { ...dc.rgst },
    //edit_at:{...dc.},
    edit_by: { ...dc.edit },
  };

  const qcClipboard: ClipboardProp = {
    category: "QCCommon",
    exField: ["cafe_seq", "cupnote_seq"],
    load: (data) => {
      // Debug(data);
      [
        "cupnote_balance_point",
        "cupnote_aroma_point",
        "cupnote_sweetness_point",
        "cupnote_body_point",
        "cupnote_flavor_point",
        "cupnote_acidity_point",
      ].forEach((item) => runFormFunction(formFunction?.current, item, "inputSync"));
      runFormFunction(formFunction?.current, "cupnote_radar", "changeData");
    },
  };
  const qcResultClipboard: ClipboardProp = {
    category: "QCResult",
    exField: ["cafe_seq", "cupnote_seq", "brewing_seq"],
    pasteMatching: ["QCCommon", "BrewingCommon"],
    load: (data) => {
      // Debug(data);
      [
        "cupnote_balance_point",
        "cupnote_aroma_point",
        "cupnote_sweetness_point",
        "cupnote_body_point",
        "cupnote_flavor_point",
        "cupnote_acidity_point",
      ].forEach((item) => runFormFunction(formFunction?.current, item, "inputSync"));
      runFormFunction(formFunction?.current, "cupnote_radar", "changeData");
    },
  };
  const coffeebean_seq: DataColumnField = {
    ...dc.selectSearch,
    label: "coffeebean_select_label",
    labelClassName: dc.strongLabelClassName,
    inputClassName: "w-full",
    widthFull: true,
    tooltip: true,
    tooltipTransition: false,
    tooltipPlacement: "topLeft",
    dataUrl: "/api/cafe/coffeebean/default/code",
    dataLabel: {
      value: "coffeebean_seq",
      label: [
        params?.locale === enLocale
          ? { field: "coffeebean_name", subs: "coffeebean_nick" }
          : { field: "coffeebean_name_locale", subs: "coffeebean_nick_locale" },
      ],
      labelSort: true,
    },
  };

  switch (params?.page.page ?? "") {
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_cafe","system_TABLE_NAME":"cupnote_coffeebean","system_table_pk":["cafe_seq","coffeebean_seq","cupnote_seq"],"system_table_manual_increment":"cupnote_seq","system_table_page":"QCCoffeebean","system_table_path":"api/cafe/qc/coffeebean","system_table_page_name":"QCCoffeebean","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["cafe"],"system_cafe_auth":"cafe","system_table_mapper":"cafeqc","system_table_detail_result":"detail_result","system_table_search_column":["cupnote_main","coffeebean_seq"],"system_table_order_column":["cupnote_main"]}
    //--info--}
    case "QCCoffeebean":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/cafe/qc/coffeebean/detail/", saveFetch: { fetchUrl: "/api/cafe/qc/coffeebean/edit" } },
        listFetch: { fetchUrl: "/api/cafe/qc/coffeebean/list" },
        dataResultName: "detail_result",
        dataName: "QCCoffeebeanData",
        clipboard: qcClipboard,
        editReload: true,
        editCheck: true,
        resetClassList: false,
        dataInit: (data: any) => {
          qcCommonInit(data, form?.current, formMemo?.current, formFunction?.current, dataFunction?.current);
        },
        dataCols: {
          coffeebean_seq: {
            ...coffeebean_seq,
            dataProp: {
              load: (data, select_data) => {
                Debug(data, select_data);
                if (select_data) {
                  form?.current?.setFieldsValue({
                    cupnote_name_locale: select_data["coffeebean_name_locale"],
                    cupnote_name: select_data["coffeebean_name"],
                  });
                  setTimeout(() => {
                    runFormFunction(formFunction?.current, "cupnote_radar", "changeLabel");
                  }, dc.setTimeoutDelay);
                }
              },
            },
            // selectPropOption: { reloadButtonFront: true },
            // selectWithLoad: selectWithList,
            onChange: (data) => {
              const temp_result = runFormFunction(formFunction?.current, "coffeebean_seq", "selectData");
              const select_data = temp_result.result;
              if (select_data) {
                form?.current?.setFieldsValue({
                  cupnote_name_locale: select_data["coffeebean_name_locale"],
                  cupnote_name: select_data["coffeebean_name"],
                });
                setTimeout(() => {
                  runFormFunction(formFunction?.current, "cupnote_radar", "changeLabel");
                }, dc.setTimeoutDelay);
              }
            },
            // onPressEnter: (e) => {
            //   //addGreenbeanList(false);
            // },
          },
          ...qcNamesCols,
          ...qcCommonCols(
            form,
            formFunction?.current,
            dataFunction?.current,
            params?.locale,
            [params?.locale === enLocale ? "cupnote_name" : "cupnote_name_locale"],
            alertContext,
            ta,
          ),
          ...qcSubCols,
        },
        listColLinkField: ["coffeebean_seq", "cupnote_seq"],
        listSearch: [
          // { ...dc.year, field: "search0", label: "roasting_result_year", placeholder: "roasting_result_year" },
          // { ...dc.date, field: "search1", label: "roasting_result_date", placeholder: "roasting_result_date" },
          { ...dc.listSearchUse, field: "search0", label: "cupnote_main", placeholder: "cupnote_main" },
        ],
        listSearchSelect: [{ ...dc.input, field: "search_title_all", label: "cupnote_name_locale", placeholder: "cupnote_name_locale" }],
        listOrder: ["cupnote_main_orderdesc", "cupnote_main_orderasc", "cupnote_name_locale_orderasc", "cupnote_name_locale_orderdesc"],
        listCols: [
          // "cafe_seq",
          // "coffeebean_seq",
          params?.locale === enLocale ? "cupnote_name" : "cupnote_name_locale",
          // "cupnote_seq",
          "rgst_user",
          {
            field: "cupnote_main",
            label: "cupnote_main_list_label",
            transition: true,
            valueList: dc.listUseLabel,
          },
        ],
        listColMobileTitle: params?.locale === enLocale ? "cupnote_name" : "cupnote_name_locale",
      };
    default:
      return undefined;
  }
};
